import { abyssColors, primary } from '@/theme/colors';
import { Stack, Typography, styled as muiStyled } from '@mui/material';

export const StageColumn = muiStyled(Stack)(() => ({
  background: primary.TintedBlue,
  scrollSnapAlign: 'start',
  height: 'fit-content',
  borderRadius: '0.8rem',
  padding: '2.4rem',
}));

export const Title = muiStyled(Typography)(() => ({
  color: primary.independence,
  fontSize: '1.6rem',
  fontWeight: 500,
  lineHeight: '100%',
}));

export const Count = muiStyled(Title)(() => ({
  color: abyssColors.primary[400],
}));

export const tooltipStyles = {
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#000000B8',
    color: abyssColors.primary[50],
    opacity: 1,
    fontSize: '1rem',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 500,
  },
  '& .MuiTooltip-arrow': {
    color: '#000000B8',
  },
};

export const stageDialogStyles = {
  '.MuiDialog-container': {
    alignItems: 'baseline',
    paddingTop: '14.8rem',
  },
  borderRadius: '8px',
};

export const DialogTitleStyle = {
  padding: '2.4rem 2.4rem 0.8rem 2.4rem',
};

export const DialogActionsStyle = {
  mr: 3,
  pb: 3,
  pt: '1.4rem',
};

export const DialogActionButtonStyle = {
  '.MuiButton-root': {
    padding: '0.6rem 1.6rem',
    textTransform: 'uppercase',
    fontWeight: 500,
    lineHeight: '2.4rem',
    letterSpacing: '0.04rem',
    fontSize: '1.4rem',
  },
};
